import React from 'react';
import Chart from 'react-apexcharts';

const data = {
  series: [{
    name: 'Projected Revenue',
    data: [2.3, 3.1, 4.0, 4.8, 5.5, 6.2, 7.1, 8.3, 9.2, 10.1, 11.5, 12.4],
  }],
  options: {
    chart: {
      height: 300,
      type: 'area',
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    },
    yaxis: {
      labels: {
        formatter: (value: number) => `$${value}M`,
      },
    },
    tooltip: {
      y: {
        formatter: (value: number) => `$${value}M`,
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.9,
        stops: [0, 90, 100],
      },
    },
    colors: ['#8884d8'],
  },
};

export function RevenueProjection() {
  return (
    <div className="rounded-lg bg-white p-6 shadow">
      <h3 className="text-lg font-medium text-gray-900">Revenue Projection</h3>
      <div className="mt-2">
        <div className="h-[300px]">
          <Chart
            options={data.options as any}
            series={data.series}
            type="area"
            height={300}
          />
        </div>
      </div>
    </div>
  );
}